import { render, staticRenderFns } from "./AtendimentoLead.vue?vue&type=template&id=19c07cc8"
import script from "./AtendimentoLead.vue?vue&type=script&lang=ts"
export * from "./AtendimentoLead.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports